export const API_ENDPOINTS = {
  SETTINGS: {
    FETCH_SETTINGS_FORM: (name) =>
      `/forms?formName=${encodeURIComponent(name)}`,
    FETCH_SETTINGS_ROWS: (name) =>
      `/settings?referenceName=${encodeURIComponent(name)}`,
    ADD_SETTINGS: (name) =>
      `/settings?referenceName=${encodeURIComponent(name)}`,
    UPDATE_SETTINGS: (id, name) =>
      `/settings/${encodeURIComponent(id)}?referenceName=${encodeURIComponent(name)}`,
    UPDATE_SETTINGS_STATUS: (id, status, name) =>
      `/settings/update-status/${encodeURIComponent(id)}?referenceName=${encodeURIComponent(name)}&status=${status}`,
    DELETE_SETTINGS: (id, name) =>
      `/settings/${encodeURIComponent(id)}?referenceName=${encodeURIComponent(name)}`,
  },

  // module settings
  MODULE_SETTINGS: {
    FETCH_MODULE_FORM: (name) => `/forms?formName=${encodeURIComponent(name)}`,
    FETCH_MODULE_DATA: (name) =>
      `/module-settings?referenceName=${encodeURIComponent(name)}`,
    ADD_SETTINGS: (name) =>
      `/module-settings?referenceName=${encodeURIComponent(name)}`,
    UPDATE_SETTINGS: (id, name) =>
      `/module-settings?moduleId=${encodeURIComponent(id)}&referenceName=${encodeURIComponent(name)}`,
    UPDATE_SETTINGS_STATUS: (moduleId, status, referenceName) =>
      `/module-settings/status-update?referenceName=${encodeURIComponent(referenceName)}&moduleId=${moduleId}`,

    DELETE_SETTINGS: (moduleId, referenceName) =>
      `/module-settings?moduleId=${moduleId}&referenceName=${encodeURIComponent(referenceName)}`,
  },
  ORGANIZATION: {
    FETCH_ORGANIZATION: () => `/organization`,
    UPDATE_ORGANIZATION: (id) => `/organization/${id}`,
    DELETE_ORGANIZATION: (id) => `/organization/${id}`,
    FETCH_ORGANIZATION_LOGO: (logoId) =>
      `/organization/file/${encodeURIComponent(logoId)}`,
    UPDATE_ORGANIZATION_STATUS: (id) => `/organization/org-status-update/${id}`,
    ADD_ORGANIZATION: () => `/organization`,
    COUNTRY_DROPDOWN: `country`,
    SMTP_DROPDOWN: `/smtp`,
    STATE_DROPDOWN: (country) => `country/state?country=${country}`,
    SMTP_SERVER_DROPDOWN: (provider) => `/smtp/server?provider=${provider}`,
    TOWN_DROPDOWN: (state, country) =>
      `country/city?state=${state}&country=${country}`,
    SMTP_PORT_DROPDOWN: (provider, server) =>
      `/smtp/port?provider=${provider}&server=${server}`,
  },
  SUBORGANIZATION: {
    FETCH_SUBORGANIZATION: () => `/organization/organization-map`,
    UPDATE_SUBORGANIZATION: (id) => `/organization/map/${id}`,
    DELETE_SUBORGANIZATION: (id) => `/organization/map/${id}`,
    ADD_SUBORGANIZATION: () => `/organization/map`,
    UPDATE_SUBORGANIZATION_STATUS: (id) =>
      `/organization/orgMap-status-update/${id}`,
    FETCH_UNMAP_ORGANIZATION: () => `/organization/organization-nonmap`,
  },
  MENU: {
    FETCH_SETTINGS: ({ referenceName }) =>
      `/settings?referenceName=${referenceName}`,
    ADD_MENU: () => `/menu`,
    FETCH_MENU: () => `/menu`,
    UPDATE_STATUS: (menuId) => `/menu/status/${menuId}`,
    UPDATE_MENU: (menuId) => `/menu/${menuId}`,
    DELETE_MENU: (menuId) => `/menu/${menuId}`,
  },
  SUBMENU: {
    FETCH_SUBMENU: () => `/menu/submenus`,
    FETCH_SUBMENU_MENU_NAME: ({ name, value }) =>
      `/forms/fetch-options?name=${name}&value=${value}&collectionName=menus&filter=status:Active:String,isSubmenu:true:boolean`,
    ADD_SUBMENU: (menuId) => `/menu/submenu/${menuId}`,
    UPDATE_SUBMENU: (subMenuId) => `/menu/subMenu/${subMenuId}`,
    UPDATE_STATUS: (subMenuId) => `/menu/subMenu-status/${subMenuId}`,
    DELETE_MENU: (subMenuId) => `/menu/subMenu/${subMenuId}`,
  },
  ROLESANDPERMISSION: {
    ADD_ROLE: () => `/role`,
    FETCH_ROLE: () => `/role`,
    UPDATE_ROLE: (id) => `/role/${id}/update-role`,
    DELETE_ROLE: (id) => `/role/${id}`,
    FETCH_ROLESANDPERMISSION: () => `/role/all`,
    UPDATE_PERMISSION: (id) => `/role/${id}`,
    UPDATE_ROLE_STATUS: (id) => `/role/${id}/status-update`,
  },
  ADMINHOLIDAY: {
    ADD_HOLIDAY: () => `/holidays/admin-holidays`,
    FETCH_ALL_HOLIDAYS: (month, state, location, type) => {
      const queryParams = new URLSearchParams();
      if (month) queryParams.append("month", month);
      if (state) queryParams.append("state", state);
      if (location) queryParams.append("location", location);
      if (type) queryParams.append("type", type);

      const queryString = queryParams.toString();
      return queryString
        ? `/holidays?${queryString}&country=India`
        : `/holidays`;
    },
    UPDATE_HOLIDAY: (id) => `/holidays?id=${id}`,
    DELETE_HOLIDAY: (id) => `/holidays/${id}`,
  },
  PROFILE_LOG:{
    PROFILELOG: (pageNo, pageSize, search, empId) => {
      const queryParams = new URLSearchParams();
      if (pageNo) queryParams.append("pageNo", pageNo);
      if (pageSize) queryParams.append("pageSize", pageSize);
      if (search) queryParams.append("search", search);
      if (empId) queryParams.append("empId", empId);
      const qs = queryParams.toString();
      return `/profileLog/getAllProfileLogs${qs ? `?${qs}` : ""}`;
    },
  }
};
